<!-- 報告不要業者 事業場 -->
<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col>
            <div
              class="text-right mb-3"
            >
              <v-btn
                color="primary"
                @click="addButtonClickEvent"
              >
                事業場の追加&nbsp;<v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
            <v-card outlined>
              <v-data-table
                :headers="tableHeaders"
                :items="traderLocations"
                :items-per-page="-1"
                dense
                disable-sort
                hide-default-footer
              >
                <template v-slot:[`item.name`]="{ item }">
                  <span :title="item.name">{{ item.name | truncate(20) }}</span>
                </template>

                <template v-slot:[`item.address`]="{ item }">
                  <div>〒{{ item.zip_code }}</div>
                  <span>{{ item.address | truncate(25) }}</span>
                </template>

                <template v-slot:[`item.editable`]="{ item }">
                  <v-btn
                    :icon="$vuetify.breakpoint.mdAndUp"
                    :small="$vuetify.breakpoint.smAndDown"
                    :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                    @click="editButtonClickEvent(item)"
                  >
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                      mdi-file-edit-outline
                    </v-icon>
                    <span v-else>編集</span>
                  </v-btn>
                  <v-btn
                    v-if="!isDemoEnv"
                    :icon="$vuetify.breakpoint.mdAndUp"
                    :small="$vuetify.breakpoint.smAndDown"
                    :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                    @click="deleteButtonClickEvent(item)"
                  >
                    <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                      mdi-trash-can-outline
                    </v-icon>
                    <span v-else>削除</span>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- ページャ -->
    <v-row dense>
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
    <location-dialog
      :enable-dialog="enableLocationDialog"
      :master-trader="masterTrader"
      :trader-id="traderId"
      :target-id="targetLocationId"
      @closeEvent="closeLocationDialog"
      @registerEvent="locationDialogCallback"
    />  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Confirm from '../../../../../components/Confirm'
import LocationDialog from '../dialogs/_LocationDialog'

export default {
  name: 'TraderLocationForm',
  components: {
    Confirm,
    LocationDialog
  },
  mixins: [
  ],
  props: {
    masterTrader: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      enableLocationDialog: false,
      traderId: null,
      targetLocationId: null,
      tableHeaders: [
        { value: 'code', text: '事業場コード' },
        { value: 'name', text: '事業場名' },
        { value: 'location_type_name', text: '事業場区分' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'editable', text: '', align: 'end' },
      ],
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      traderLocations: [],
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
  },
  created () {
    this.traderId = Number(this.$route.params.id)
    this.searchTraderLocations()
  },
  methods: {
    ...mapActions('DriverMasterNonReportingTraderLocation', {
      'fetchTraderLocations': 'index',
      'deleteTraderLocation' : 'destroy',
    }),
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.targetLocationId = null
      this.enableLocationDialog = true
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetLocationId = item.id
      this.enableLocationDialog = true
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTraderLocation({ trader_id: this.traderId, id: item.id }).then(() =>{
            this.page = 1
            this.searchTraderLocations()
          })
        }
      })
    },
    /**
     * モーダルを閉じる
     */
    closeLocationDialog () {
      this.enableLocationDialog = false
    },
    /**
     * モーダルからのコールバック処理
     */
    locationDialogCallback () {
      this.enableLocationDialog = false
      this.searchTraderLocations()
    },
    changePage () {
      this.searchTraderLocations()
    },
    /**
     * 事業場検索
     */
    searchTraderLocations () {
      this.fetchTraderLocations({ trader_id: this.$route.params.id , page: this.page}).then((content) => {
        this.traderLocations = content.trader_locations
        this.pagination = content.pagination
      })
    }
  },
}
</script>

<style scoped lang="scss">
.wrap_text {
  display: inline-block;
  overflow-wrap: break-word;
}
</style>
